import type { FC} from "react";
import { forwardRef } from "react";

import type { ITextbox} from "@Components/Textbox";
import { Textbox } from "@Components/Textbox";

export const TextboxWrapper: FC<ITextbox> = forwardRef<HTMLInputElement, ITextbox>(
    (props, inputRef) => <Textbox {...props} forwardRef={inputRef} />,
);
